import {useCallback, useEffect} from 'react'
import reduxStore from "../redux/store";
import {clearStepperStateCloseValidator, setStepperStateCloseValidator, setStepperStateDeleteFormDraftFunction, clearStepperStateDeleteFormDraftFunction,
    setStepperStateSaveFormDraftFunction, clearStepperStateSaveFormDraftFunction} from "../redux/actions";


const useStepperStateCloseValidator = (formId, customCloseValidatorFunction, deleteFormDraftFunc, saveFormDraftFunc) => {

    const defaultCloseValidatorFunction = useCallback(() => {
        //domyślna implementacja zakłada, że formularz zawiera <SaveFormikValues
        const dirty = reduxStore.getState()?.formValues?.[formId + "_dirty"];
        const draftLoaded = reduxStore.getState()?.formValues?.[formId + "_draftLoaded"];
        return dirty !== true && !draftLoaded;
    }, [formId])

    useEffect(() => {
        reduxStore.dispatch(
            setStepperStateCloseValidator(customCloseValidatorFunction ? customCloseValidatorFunction : defaultCloseValidatorFunction));
        if (!!deleteFormDraftFunc && typeof deleteFormDraftFunc === 'function')
            reduxStore.dispatch(setStepperStateDeleteFormDraftFunction(deleteFormDraftFunc));
        if (!!saveFormDraftFunc && typeof saveFormDraftFunc === 'function')
            reduxStore.dispatch(setStepperStateSaveFormDraftFunction(saveFormDraftFunc))
        return () => {
            reduxStore.dispatch(clearStepperStateCloseValidator());
            reduxStore.dispatch(clearStepperStateDeleteFormDraftFunction());
            reduxStore.dispatch(clearStepperStateSaveFormDraftFunction());
        }
    }, [customCloseValidatorFunction, defaultCloseValidatorFunction, formId, deleteFormDraftFunc, saveFormDraftFunc])
}

export default useStepperStateCloseValidator;